import * as React from 'react';
import {DefaultButton, Dropdown, PrimaryButton} from '@fluentui/react';
import { Panel } from '@fluentui/react';
import {useState, useContext, useEffect} from "react";
import {DatePicker, SpinButton, Stack, TextField} from "@fluentui/react";
import AuthContext from "../../Services/AuthContext";
import {dbDate} from "../../Utilities/dbDate";

function AddPayment(props) {
    const [user] = useContext(AuthContext);
    const [value, setValue] = useState(0);
    const [date, setDate] = useState(null);
    const [notes, setNotes] = useState('');
    const [invoices, setInvoices] = useState([{key: 0, text: 'Transakcja Główna'}]);
    const [invoice, setInvoice] = useState({key: 0, text: 'Transakcja Główna'});

    const _submit = (e) => {
        e.preventDefault();
        const data = {value: value, date: dbDate(date), notes: notes, transactionId: props.transactionId, transaction_invoice_id: invoice.key === 0 ? null : invoice.key};
        fetch('/api/payment', {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    useEffect(() => {
        const abortController = new AbortController();
        if (props.add) {
            setValue(0);
            setDate(null);
            setNotes('');
            async function fetchInvoices() {
                await fetch(`/api/transaction/${props.transactionId}/invoice`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        let invoices = data.map((item) => {
                            return {key: item.id, text: item.invoice_number};
                        });
                        invoices.unshift({key: 0, text: 'Transakcja Główna'});
                        setInvoices(invoices);
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchInvoices();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddPayment'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);

    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Płatność"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddPayment'>
                <SpinButton
                    label={'Wartość Wpłaty:'}
                    labelPosition={'top'}
                    min={0}
                    step={0.01}
                    incrementButtonAriaLabel={'Increase value by 1'}
                    decrementButtonAriaLabel={'Decrease value by 1'}
                    value={value}
                    onChange={(e) => setValue(e.target.value || '')}
                />
                <DatePicker
                    label="Data"
                    isRequired={true}
                    placeholder="Wybierz datę..."
                    ariaLabel="Wybierz datę"
                    value={date}
                    onSelectDate={(e) => setDate(e || '')}
                />
                <TextField label="Opis" multiline autoAdjustHeight value={notes} onChange={(e) => setNotes(e.target.value || '')}/>
                <Dropdown
                    label="Płatność za"
                    selectedKey={invoice ? invoice.key : undefined}
                    onChange={(e, item) => setInvoice(item)}
                    placeholder="Wybierz z listy"
                    options={invoices}
                />
            </form>
        </Panel>
    )
}

export default AddPayment;